module.exports = __webpack_public_path__ + "static/media/Lexington-Condo-Homes-4th_amendment.ed2a131d.pdf";